<div class="container-proyecto">
    <div class="titulo">
        <h1>Proyectos</h1>
        <div>
          <p>Mis proyectos (Web y Movil)</p>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div *ngFor="let proyecto of proyectos" class="col-sm-12 col-lg-6">
                <div class="tarjeta-proyecto">
                    <img src="assets/images/{{proyecto.id}}.png" class="card-img-top" alt="...">
                    <div class="card-body">
                      <h5 class="card-title">{{proyecto.name}}</h5>
                      <p class="card-text">{{proyecto.description}}.</p>
                      <p><strong>Lenguajes: </strong>{{proyecto.language}}</p>
                      <p class="card-text"><small class="text-muted">Last updated {{proyecto.updated_at}}</small></p>
                      <hr>
                      <div class="github">
                        <a href="{{proyecto.html_url}}" target="_blank" class="btn btn-dark">
                          <i class="fab fa-github"></i> Ver proyecto en Github.
                        </a>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</div>
<!-- <div>Teachable Machine Image Model</div>
<button type="button" onclick="init()">Start</button>
<div id="webcam-container"></div>
<div id="label-container"></div>
<script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@1.3.1/dist/tf.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/@teachablemachine/image@0.8/dist/teachablemachine-image.min.js"></script>
<script type="text/javascript">
    // More API functions here:
    // https://github.com/googlecreativelab/teachablemachine-community/tree/master/libraries/image

    // the link to your model provided by Teachable Machine export panel
    const URL = "https://teachablemachine.withgoogle.com/models/w9DHXOQ9q/";

    let model, webcam, labelContainer, maxPredictions;

    // Load the image model and setup the webcam
    async function init() {
        const modelURL = URL + "model.json";
        const metadataURL = URL + "metadata.json";

        // load the model and metadata
        // Refer to tmImage.loadFromFiles() in the API to support files from a file picker
        // or files from your local hard drive
        // Note: the pose library adds "tmImage" object to your window (window.tmImage)
        model = await tmImage.load(modelURL, metadataURL);
        maxPredictions = model.getTotalClasses();

        // Convenience function to setup a webcam
        const flip = true; // whether to flip the webcam
        webcam = new tmImage.Webcam(200, 200, flip); // width, height, flip
        await webcam.setup(); // request access to the webcam
        await webcam.play();
        window.requestAnimationFrame(loop);

        // append elements to the DOM
        document.getElementById("webcam-container").appendChild(webcam.canvas);
        labelContainer = document.getElementById("label-container");
        for (let i = 0; i < maxPredictions; i++) { // and class labels
            labelContainer.appendChild(document.createElement("div"));
        }
    }

    async function loop() {
        webcam.update(); // update the webcam frame
        await predict();
        window.requestAnimationFrame(loop);
    }

    // run the webcam image through the image model
    async function predict() {
        // predict can take in an image, video or canvas html element
        const prediction = await model.predict(webcam.canvas);
        for (let i = 0; i < maxPredictions; i++) {
            const classPrediction =
                prediction[i].className + ": " + prediction[i].probability.toFixed(2);
            labelContainer.childNodes[i].innerHTML = classPrediction;
        }
    }
</script>
 -->